import { useQuery } from '@tanstack/react-query'

import { GetUserViewModel } from '@/types/pam-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'
import { useJwtToken } from '@/app/_utils/session/use-jwt-token'

const useUser = () => {
    const { data: jwtToken, isLoading: isJwtLoading } = useJwtToken()

    const {
        data: user,
        refetch,
        isLoading: isUserLoading,
        isFetching,
        isError,
        isPending,
    } = useQuery<GetUserViewModel>({
        queryKey: QueryKeys.User.UserInfo,
        queryFn: () =>
            fetchRequest({
                method: 'GET',
                serviceName: 'pam',
                endpoint: `/users/_current`,
                openAuthModal: false,
            }),
        retryOnMount: false,
        refetchOnMount: false,
        enabled: !!jwtToken,
    })

    const userQueryLoading = isUserLoading || isPending
    const isLoading = isJwtLoading || (!!jwtToken && userQueryLoading)

    return {
        isLoggedIn: !!user,
        isLoading,
        user,
        refetch,
        isFetching,
        isError,
    }
}

export default useUser
